import { axiosJwt } from '@/shared/auth/axiosJwt';

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_LICITACOES_PORT}${process.env.VUE_APP_API_PATH}/licitacoes`;

export default {
    ConformidadeLegal(solicitacaoId, arquivos, observacao) {
        const formData = new FormData();
        arquivos.forEach((arquivo) => {
            formData.append('anexos', arquivo);
        });
        formData.append('observacao', observacao);
        return axiosJwt.post(`${api}/solicitacoes/${solicitacaoId}/conformidadeLegal`, formData);
    },
    elaborarParecer(solicitacaoId, arquivos, observacao) {
        const formData = new FormData();
        arquivos.forEach((arquivo) => {
            formData.append('anexos', arquivo);
            formData.append('observacao', observacao);
        });
        return axiosJwt.post(`${api}/solicitacoes/${solicitacaoId}/elaborarParecer`, formData);
    },
    encaminharHomologacao(solicitacaoId, arquivos, observacao) {
        const formData = new FormData();
        arquivos.forEach((arquivo) => {
            formData.append('anexos', arquivo);
        });
        formData.append('observacao', observacao);
        return axiosJwt.post(`${api}/solicitacoes/${solicitacaoId}/encaminharHomologacao`, formData);
    },
    processoCancelado(solicitacaoId, arquivos, observacao) {
        const formData = new FormData();
        arquivos.forEach((arquivo) => {
            formData.append('anexos', arquivo);
        });
        formData.append('observacao', observacao);
        return axiosJwt.post(`${api}/solicitacoes/licitacao/${solicitacaoId}/processocancelado`, formData);
    },
    documentoProcessoCancelado(solicitacaoId, arquivos, observacao) {
        const formData = new FormData();
        arquivos.forEach((arquivo) => {
            formData.append('anexos', arquivo);
        });
        formData.append('observacao', observacao);
        return axiosJwt.post(`${api}/solicitacoes/licitacao/${solicitacaoId}/documentoprocessocancelado`, formData);
    },
    solicitarAjustesConformidade(solicitacaoId, arquivos, observacao) {
        const formData = new FormData();
        arquivos.forEach((arquivo) => {
            formData.append('anexos', arquivo);
            formData.append('observacao', observacao);
        });
        return axiosJwt.post(`${api}/solicitacoes/${solicitacaoId}/solicitarajustesconformidade`, formData);
    },
    voltarEtapa(solicitacaoId, etapaAtual, proximaEtapa, observacao, arquivos) {
        const formData = new FormData();
        formData.append('etapaAtual', etapaAtual);
        formData.append('proximaEtapa', proximaEtapa);
        formData.append('observacao', observacao);
        arquivos.forEach((arquivo) => {
            formData.append('anexos', arquivo);
        });
        return axiosJwt.post(`${api}/solicitacoes/${solicitacaoId}/voltaretapa`, formData);
    },

    finalizarSolicitacao(solicitacaoId, arquivos, observacao) {
        const formData = new FormData();
        arquivos.forEach((arquivo) => {
            formData.append('anexos', arquivo);
        });
        formData.append('observacao', observacao);
        return axiosJwt.post(`${api}/solicitacoes/${solicitacaoId}/finalizarsolicitacao`, formData);
    },
    enviarParaComprometerContratacao(solicitacaoId, arquivos, observacao) {
        const formData = new FormData();
        arquivos.forEach((arquivo) => {
            formData.append('anexos', arquivo);
        });
        formData.append('observacao', observacao);
        return axiosJwt.post(`${api}/solicitacoes/${solicitacaoId}/enviarcomprometercontratacao`, formData);
    },
    cancelarSolicitacao(solicitacaoId, arquivos, observacao) {
        const formData = new FormData();
        arquivos.forEach((arquivo) => {
            formData.append('anexos', arquivo);
        });
        formData.append('observacao', observacao);
        return axiosJwt.post(`${api}/solicitacoes/${solicitacaoId}/cancelarprocesso`, formData);
    },
    solicitarAjustesElaborarParecer(solicitacaoId, arquivos, observacao) {
        const formData = new FormData();
        arquivos.forEach((arquivo) => {
            formData.append('anexos', arquivo);
        });
        formData.append('observacao', observacao);
        return axiosJwt.post(`${api}/solicitacoes/${solicitacaoId}/solicitarajusteselaborarparecer`, formData);
    },
};
